// extracted by mini-css-extract-plugin
export default {"box":"Lpr6F1pG2N1Gk7kV3NQ35w=="};